export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024;

export type UploadResult = {
  objectPath: string;
  url: string;
};

export async function uploadImage(file: File): Promise<UploadResult> {
  if (!file.type.startsWith("image/")) {
    throw new Error("Only image files are allowed.");
  }
  if (file.size > MAX_UPLOAD_BYTES) {
    throw new Error("Image must be 5MB or smaller.");
  }
  const reqRes = await fetch("/api/storage/uploads/request-url", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      name: file.name,
      size: file.size,
      contentType: file.type,
    }),
  });
  if (!reqRes.ok) {
    const text = await reqRes.text().catch(() => "");
    throw new Error(text || "Failed to get upload URL");
  }
  const { uploadURL, objectPath } = (await reqRes.json()) as {
    uploadURL: string;
    objectPath: string;
  };
  const putRes = await fetch(uploadURL, {
    method: "PUT",
    headers: { "Content-Type": file.type },
    body: file,
  });
  if (!putRes.ok) {
    throw new Error(`Upload failed (${putRes.status})`);
  }
  return { objectPath, url: storedImageUrl(objectPath) ?? "" };
}

export function storedImageUrl(objectPath: string | null | undefined): string | null {
  if (!objectPath) return null;
  if (/^https?:\/\//.test(objectPath)) return objectPath;
  if (objectPath.startsWith("/objects/")) return `/api/storage${objectPath}`;
  if (objectPath.startsWith("/public-objects/")) return `/api/storage${objectPath}`;
  return objectPath;
}
